export default "__VITE_ASSET__Y5pVz2De__"